import React, { useEffect,Fragment, useState, useGlobal } from 'reactn';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from "axios";

import { toast_success, toast_warning } from '../api/api';
import { navigatePage, ordinal_suffix_of } from '../lib/lib';

const useStyles = makeStyles(theme => ({
    textfield_label: {
        fontWeight: 'bold',
        fontSize: '1.2em',
    },
    button_create_template: {
        width: '100%',
        height: 56,
        marginTop: 19,
        marginBottom: 24,
        borderWidth: 2,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        backgroundColor: 'white',
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: 'bold',
        fontSize: '1.1em',
        transition: 'all .3s',
        whiteSpace: 'nowrap',
        '&:hover': {
            borderWidth: 2,
            backgroundColor: theme.palette.secondary.main,
            color: 'white',
        },
    },
    button_wizard_back: {
        width: '100%',
        marginRight: 5,
        height: 56,
        marginTop: 19,
        marginBottom: 24,
        borderWidth: 2,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
        backgroundColor: 'white',
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: 'bold',
        fontSize: '1.1em',
        transition: 'all .3s',
        whiteSpace: 'nowrap',
        '&:hover': {
            borderWidth: 2,
            backgroundColor: theme.palette.secondary.main,
            color: 'white',
        },
    },
    button_wizard_next: {
        width: '100%',
        marginLeft: 5,
        height: 56,
        marginTop: 19,
        marginBottom: 24,
        borderWidth: 2,
        color: 'white',
        backgroundColor: theme.palette.secondary.main,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: 'bold',
        fontSize: '1.1em',
        transition: 'all .3s',
        whiteSpace: 'nowrap',
        '&:hover': {
            borderWidth: 2,
            color: 'white',
            backgroundColor: theme.palette.secondary.main,
        },
    },
}));

const Entity = props => {
    const classes = useStyles();

    const [sToken] = useGlobal('sToken');
    const [sApiUrl] = useGlobal('sApiUrl');
    const [sViewerDomainName] = useGlobal('sViewerDomainName');
    

    const [iEditingDocId] = useGlobal('iEditingDocId');
    const [sEditingDocTemplateApiKey] = useGlobal('sEditingDocTemplateApiKey');

    const [sReferrerDocTempEdit] = useGlobal('sReferrerDocTempEdit');

    const [bLoading, setLoading] = useState(false);

    useEffect(() => {
        window.addEventListener("message", function(e) {
            if(e.data.saveFlag == "N" || e.data.saveFlag == "S") {
                if (sReferrerDocTempEdit === 'document_template_creation') {
                    navigatePage('/document_template', props);
                }
            } else if(e.data.saveFlag == "R") {
                if (sReferrerDocTempEdit === 'my_document/sign_participant') {
                    navigatePage('/my_document/sign_request_settings', props);
                }
            }
            
          });
          
    }, [props]);

    return (
        <div
            style={{
                height: 'calc(100% - 90px)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
            }}
        >
            <iframe   
                //운영             
                //src={`https://onlinesign.co.kr/viewer/?id=${sEditingDocTemplateApiKey}`}
                //개발
                //src={`http://pilot.onlinesign.co.kr/viewer/?id=${sEditingDocTemplateApiKey}`}
                //로컬
                src={`${sViewerDomainName}/viewer/?id=${sEditingDocTemplateApiKey}`}
                style={{
                    width: 'calc(100%)',
                    flex: 1,
                    border: 'none',
                    marginBottom : '30px',
                }}
            />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 0,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        maxWidth: 500,
                        minWidth: 500,
                    }}
                >
                    {bLoading && (
                        <div
                            style={{
                                flex: 1,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <CircularProgress disableShrink />
                        </div>
                    )}
                    {/*!bLoading && (
                        <Fragment>
                            <Button
                                color="secondary"
                                className={classes.button_wizard_next}
                                onClick={() => {
                                    if (sReferrerDocTempEdit === 'document_template_creation') {
                                        navigatePage('/document_template', props);
                                    }
                                    if (sReferrerDocTempEdit === 'my_document/sign_participant') {
                                        navigatePage('/my_document/sign_request_settings', props);
                                    }
                                }}
                            >
                                다음
                            </Button>
                        </Fragment>
                            )*/}
                </div>
            </div>
        </div>
    );
};

export default Entity;